// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-item-details {
  display: flex;
  gap: var(--spacing-regular);
}
.cart-item-details .item-image {
  width: 88px;
  cursor: pointer;
}
.cart-item-details .image-unavailable-product {
  width: 88px;
  filter: grayscale(100%);
}
.cart-item-details .item-info .vert-paragraph.unavailable-badge {
  width: 90px;
  font-size: var(--font-small);
  font-weight: 500;
  text-align: center;
  color: var(--color-neutral-dark-lighter);
  background-color: var(--color-neutral-light-lighter);
  border-radius: 16px;
  border: var(--border-width) solid var(--color-border);
  margin-bottom: var(--spacing-extra-small);
}
.cart-item-details .item-info .vert-paragraph.item-name {
  margin-bottom: var(--spacing-small);
  font-size: var(--font-paragraph);
  font-weight: 600;
  line-height: var(--font-paragraph-line) !important;
  cursor: pointer;
}
.cart-item-details .item-info .vert-paragraph.item-seller {
  font-size: var(--font-small);
  font-weight: 400;
  cursor: auto;
}
.cart-item-details .item-info .vert-paragraph.item-shipping-value {
  font-size: var(--font-small);
  font-weight: 500;
  cursor: auto;
}
.cart-item-details .item-info .vert-paragraph.item-shipping-value span {
  font-weight: 600;
}
.cart-item-details .item-info .vert-paragraph.item-shipping-value span.is-free {
  color: var(--color-highlight);
}
.cart-item-details .item-info .item-shipping-value {
  margin-bottom: var(--spacing-regular);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Cart/CartItemDetailsStyles.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,2BAAA;AACJ;AAHA;EAKQ,WAAA;EACA,eAAA;AACR;AAPA;EAUQ,WAAA;EACA,uBAAA;AAAR;AAKY;EACI,WAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,oDAAA;EACA,mBAAA;EACA,qDAAA;EACA,yCAAA;AAHhB;AAMY;EACI,mCAAA;EACA,gCAAA;EACA,gBAAA;EACA,kDAAA;EACA,eAAA;AAJhB;AAMY;EACI,4BAAA;EACA,gBAAA;EACA,YAAA;AAJhB;AAMY;EACI,4BAAA;EACA,gBAAA;EACA,YAAA;AAJhB;AACY;EAKQ,gBAAA;AAHpB;AAIoB;EACI,6BAAA;AAFxB;AA7CA;EAsDY,qCAAA;AANZ","sourcesContent":[".cart-item-details {\n    display: flex;\n    gap: var(--spacing-regular);\n\n    .item-image {\n        width: 88px;\n        cursor: pointer;\n    }\n\n    .image-unavailable-product {\n        width: 88px;\n        filter: grayscale(100%);\n    }\n\n    .item-info {\n        .vert-paragraph {\n            &.unavailable-badge {\n                width: 90px;\n                font-size: var(--font-small);\n                font-weight: 500;\n                text-align: center;\n                color: var(--color-neutral-dark-lighter);\n                background-color: var(--color-neutral-light-lighter);\n                border-radius: 16px;\n                border: var(--border-width) solid var(--color-border);\n                margin-bottom: var(--spacing-extra-small);\n            }\n\n            &.item-name {\n                margin-bottom: var(--spacing-small);\n                font-size: var(--font-paragraph);\n                font-weight: 600;\n                line-height: var(--font-paragraph-line) !important;\n                cursor: pointer;\n            }\n            &.item-seller {\n                font-size: var(--font-small);\n                font-weight: 400;\n                cursor: auto;\n            }\n            &.item-shipping-value {\n                font-size: var(--font-small);\n                font-weight: 500;\n                cursor: auto;\n                span {\n                    font-weight: 600;\n                    &.is-free {\n                        color: var(--color-highlight);\n                    }\n                }\n            }\n        }\n\n        .item-shipping-value {\n            margin-bottom: var(--spacing-regular);\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
